import { withInstall } from '@pc-fx-framework/utils/with-install'
import AnimPage from './src/index.vue'

export const FxAnimPage = withInstall(AnimPage)
export default FxAnimPage

